import { useGetPlantByIdQuery } from 'api';
import { Plant } from 'types';

interface Props {
  plantId: string;
}

export const useGetPlantByIdQueryInfo = ({
  plantId
}: Props): {
  isLoading: boolean;
  isFetching: boolean;
  [key: string]: unknown;
  data?: Plant;
  error?: string | unknown;
} => {
  const { data, isLoading, isFetching, error } = useGetPlantByIdQuery(plantId);

  return {
    isLoading,
    isFetching,
    error,
    data
  };
};
